import { resolveTimeZone, toInstant } from '../../util/datetime';
import { formatDurationMs, toDurationMs } from '../../util/duration';
const DATE_STYLE_OPTIONS = {
  time: {
    timeStyle: 'short'
  },
  date: {
    dateStyle: 'medium'
  },
  datetime: {
    dateStyle: 'medium',
    timeStyle: 'short'
  }
};

// Display formatting intentionally follows the viewer's locale (12h/24h, month
// names, digits) rather than forcing a canonical calendar the way day-key
// derivation does. An unresolvable instant renders as empty, matching how
// interpolation drops missing tokens.
function formatDate(value, spec, locale) {
  const instant = toInstant(value);
  if (!instant) return '';
  return new Intl.DateTimeFormat(locale, Object.assign({
    timeZone: resolveTimeZone(spec.timezone)
  }, DATE_STYLE_OPTIONS[spec.style])).format(instant);
}
function formatDuration(value, spec, locale) {
  const durationMs = toDurationMs(value);
  if (durationMs === undefined) return '';
  return formatDurationMs(durationMs, locale, spec.style);
}
export function applyFormat(value, spec, locale) {
  switch (spec.type) {
    case 'date':
      return formatDate(value, spec, locale);
    case 'duration':
      return formatDuration(value, spec, locale);
    default:
      return value === undefined || value === null ? '' : String(value);
  }
}